import { FetchNextPageOptions, InfiniteQueryObserverResult } from 'react-query';
import { useDebouncedCallback } from 'use-debounce';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component';
import styled from '@emotion/styled';

const Spinner = loadable(() => import('@com/utils/Spinner'));

interface Props {
  hasNextPage?: boolean;
  fetchNextPage: (
    options?: FetchNextPageOptions | undefined
  ) => Promise<InfiniteQueryObserverResult<any, unknown>>;
}

function LoadMoreBtn(props: Props): JSX.Element {
  /* Define state / hook */
  const { hasNextPage, fetchNextPage } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation();

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */
  const debouncedLoadMore = useDebouncedCallback(
    async () => {
      setIsLoading(true);
      await fetchNextPage();
      setIsLoading(false);
    },
    500,
    { leading: true, trailing: false }
  );

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */
  const Button = styled.button`
    font-size: 16px;
    color: var(--primary-color3);
    :hover {
      color: var(--primary-color);
    }
  `;

  /* Render */
  return hasNextPage ? (
    <div className="col-md-12 wrap-inner text-center center mb-4">
      <Button
        className="sc-button loadmore fl-button pri-3 d-flex align-items-center m-auto"
        disabled={isLoading}
        type="button"
        onClick={() => {
          debouncedLoadMore();
        }}
      >
        {t('general.loadMore')}
        <Spinner className="ml-2" width={isLoading ? 24 : 0} />
      </Button>
    </div>
  ) : (
    <div />
  );
}

export default LoadMoreBtn;
